export const ErrorMessage = {
  DEFAULT: '',
  NO_HAVE_DATA: 'No have data',
  EMAIL_REQUIRED: 'It\'s required. Please input the email address.',
  EMAIL_MAX_LENGTH_200: 'Max length 200 characters. Please try again.',
  EMAIL_VALID: 'You can use letters, numbers and periods. Please enter a valid email address.',
  COMPANY_REQUIRED: 'It\'s required. Please input the company name.',
  COMPANY_MAX_LENGTH_200: 'Max length 200 characters, letters and numbers only. Please try again.',
  CONTACT_REQUIRED: 'It\'s required. Please input the mobile number.',
  CONTACT_NUMBER_ONLY: 'This entry can contain only numbers. Please try again.',
  CONTACT_MAX_LENGTH: 'Please enter your valid mobile number.',
  BL_NUMBER_NOT_EXISTS: 'The B/L or Invoice number does not exist. Please input a valid B/L or Invoice number.',
  BL_NUMBER_REQUIRED: 'It\'s required. Please input the B/L or Invoice number.',
  BL_NUMBER_LENGTH_16: 'Please enter your 16 characters BL or Invoice number.',
  BL_AMOUNT_REQUIRED: 'It\'s required. Please input the B/L or Invoice amount.',
  BL_AMOUNT_GREATER_THAN_0: 'The amount must be more than 0. Please input again.',
  BL_NUMBER_DUPLICATED: 'Your BL or Invoice number is duplicated. Please input again.',
  BL_AMOUNT_EXCEEDS_PAYMENT_LIMIT: 'The amount exceeds the payment limit. Please input again.',
  REMARK_MAX_LENGTH_2000: 'Max length 2000, please try again.',
  EXCEL_MAX_SIZE_ERROR: 'The uploaded file exceeds the maximum file size 300 KB allowed. Please upload another file.',
  EXCEL_FILE_DOES_NOT_SUPPORT: 'The file type is not supported. Please upload XLS or XLSX file.',
  EMPTY_FILE_UPLOAD: 'Your file is empty. Please upload a valid file.',
  CURRENCY_NOT_SUPPORTED: 'The currency is not supported in your country selection. Please try again.',
  EXCEL_FILE_INCORRECT_FORMAT: 'The format of your file is not supported. Please use a compatible format when uploading.',
  PO_NUMBER_CONTAINS_SPECIAL_CHARACTER: 'This entry can contain only alphabet and numeric. Please input again.'
}
